import { Language } from '@/lib/interfaces/interfaces'

export const LANGUAGE_LABELS: Record<Language, string> = {
  es: 'Español',
  en: 'English',
  fr: 'Français',
  ca: 'Català',
  de: 'Deutsch',
  eu: 'Euskara'
}

export const LANGUAGE_FLAGS: Record<Language, string> = {
  es: '/img/flags/es-flag.svg',
  en: '/img/flags/en-flag.svg',
  fr: '/img/flags/fr-flag.svg',
  ca: '/img/flags/ca-flag.svg',
  de: '/img/flags/de-flag.svg',
  eu: '/img/flags/eu-flag.svg'
}
